import { Translatable } from "Shared/TranslatableTextContent/translatable"

export type ClientEditableConfigTranslatableKeys = 'privacyPolicy' | 'unsubscribeBlock'
export const clientEditableConfigTranslatables: Record<ClientEditableConfigTranslatableKeys, Translatable> = {
  privacyPolicy: {
    label: 'Privacy Policy',
    default: 'priv pol here',
  },
  unsubscribeBlock: {
    label: 'Unsubscribe Block',
    default: '<p class="text-center"><a href="{{unsubscribe_url|default:\'#\'}}">Click here to unsubscribe</a></p>',
  }
} as const

